import { $themeConfig } from '@themeConfig'

export default {
  namespaced: true,
  state: {
    isVerticalMenuCollapsed: (localStorage.getItem(`${$themeConfig.app.session}-menu-collapsed`) === 'true') || $themeConfig.layout.menu.isCollapsed,
  },
  getters: {},
  mutations: {
    UPDATE_VERTICAL_MENU_COLLAPSED(state, val) {
      localStorage.setItem(`${$themeConfig.app.session}-menu-collapsed`, val)
      state.isVerticalMenuCollapsed = val
    },
  },
  actions: {},
}
